import axios from "axios";

const guestUrl = "/v2/api/guests";

class GuestService {
    static getGuests(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [guestUrl].join("");
                url = url + urlP;
                let result = await axios.get(url);
                let pagingData = result.data;
                resolve(pagingData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getGuestById(guestId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${guestUrl}/${guestId}`;
                const result = await axios.get(url);
                const guestData = result.data;
                resolve(guestData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createGuest(guestData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${guestUrl}`;
                const result = await axios.post(url, guestData);
                const createdGuest = result.data;
                resolve(createdGuest);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateGuest(guestId, updatedGuestData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${guestUrl}/${guestId}`;
                await axios.put(url, updatedGuestData);
                resolve(`Guest record with ID ${guestId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteGuest(guestId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${guestUrl}/${guestId}`;
                await axios.delete(url);
                resolve(`Guest record with ID ${guestId} deleted successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }
    static patchGuestStatus(guestId, statusData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${guestUrl}/${guestId}/active`;
                await axios.patch(url, statusData);
                resolve(`Guest active status for ID ${guestId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

}

export default GuestService;
